import { render, staticRenderFns } from "./UserOmsIndex.vue?vue&type=template&id=4c785323&scoped=true&"
import script from "./UserOmsIndex.vue?vue&type=script&lang=js&"
export * from "./UserOmsIndex.vue?vue&type=script&lang=js&"
import style0 from "./UserOmsIndex.vue?vue&type=style&index=0&id=4c785323&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c785323",
  null
  
)

export default component.exports